/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const CssBaseline: ThemeOptions = {
	components: {
		MuiCssBaseline: {
			styleOverrides: (theme) => `
			${theme.fonts
				.map(
					({ family, style, display, weight, src, unicodeRange }) => `
						@font-face {
							font-family: ${family};
							font-style: ${style};
							font-display: ${display};
							font-weight: ${weight};
							src: ${src};
							unicodeRange: ${unicodeRange};
						}
						`
				)
				.join(``)}
			html, #__next { max-width: 100vw; min-height: 100vh; display: flex; flex: 1}
			body { max-width: 100vw; min-height: 100vh; display: flex; flex: 1; overflow-x: hidden}
			#__next {flex-direction: column; }
			#__next > main {flex: 1;}
			img {
				max-width: 100%;
			}
			img[src*="https://tracker.metricool.com/"] {
				display: none;
			}
			:root{
				--spacing-1: 4px;
				--spacing-2: 8px;
				--spacing-3: 12px;
				--spacing-4: 16px;
				--spacing-5: 20px;
				--spacing-6: 24px;
				--spacing-7: 32px;
				--spacing-8: 40px;
				--spacing-9: 48px;
				--spacing-10: 56px;
				--spacing-11: 64px;
				--spacing-12: 72px;
				--spacing-13: 80px;
				--spacing-14: 88px;
				--spacing-15: 96px;

				--font-size-biggest: 65px;
				--font-size-display: 40px;
				--font-size-xxl: 30px;
				--font-size-xl: 24px;
				--font-size-lg: 20px;
				--font-size-md: 18px;
				--font-size-sm: 16px;
				--font-size-body: 15px;
				--font-size-default: 14px;
				--font-size-small: 13px;
				--font-size-caption: 12px;
				--font-size-tiny: 11px;
				--font-size-micro: 10px;
			}

			nextjs-portal {
			display: none;}
      `,
		},
	},
};
